import * as React from 'react';

function TitleBlockIcon(props: React.SVGProps<SVGSVGElement>) {
	return (
		<svg width={24} height={24} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
			<text
				transform="translate(0 -1)"
				fill="#6C7680"
				fillRule="evenodd"
				fontFamily="Georgia"
				fontSize={24}
			>
				<tspan x={4} y={22}>
					{'T'}
				</tspan>
			</text>
		</svg>
	);
}

export default TitleBlockIcon;
